export const unique = (items) => {
	if (Array.isArray(items) && items.length) {
		return [...new Set(items)]
	} else {
		return []
	}
}
